import { alpha } from '@mui/material/styles';

import { isLightTheme } from '../../utils';

import type { OverWritable } from '../../@types/settings';

export const button: OverWritable = {
  MuiButton: {
    defaultProps: { disableElevation: true },

    styleOverrides: {
      sizeLarge: { height: 48 },
      containedInherit: ({ theme }) => {
        const isLight = isLightTheme(theme);

        return {
          color: isLight ? theme.palette.common.white : theme.palette.grey[800],
          backgroundColor: isLight
            ? theme.palette.grey[800]
            : theme.palette.common.white,
          '&:hover': {
            backgroundColor: isLight
              ? theme.palette.grey[700]
              : theme.palette.grey[400],
          },
        };
      },
      outlinedInherit: ({ theme }) => ({
        borderColor: alpha(theme.palette.grey[500], 0.32),
        '&:hover': {
          backgroundColor: theme.palette.action.hover,
          borderColor: theme.palette.text.primary,
        },
      }),
      textInherit: ({ theme }) => ({
        '&:hover': { backgroundColor: theme.palette.action.hover },
      }),
    },
  },
};
